"use client";

import { Loader2 } from "lucide-react";

import CTAButton from "@/src/components/cta-button";
import { Button } from "@/src/components/shadcn/ui/button";

/**
 * The wizard's footer action pair: a full-width primary CTA (which owns the ⌘⏎ shortcut via
 * `CTAButton`) plus an optional full-width outline "Back". Shared by the flow footer and the review
 * step so the two never drift. Only the primary is a `CTAButton`, so the shortcut is never ambiguous.
 */
export function StepActions({
  primaryLabel,
  primaryType = "button",
  form,
  onPrimary,
  primaryDisabled = false,
  isBusy = false,
  onBack,
  backDisabled = false,
}: {
  primaryLabel: string;
  primaryType?: "button" | "submit";
  form?: string;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  isBusy?: boolean;
  onBack?: () => void;
  backDisabled?: boolean;
}) {
  return (
    <div className="space-y-2">
      <CTAButton
        type={primaryType}
        form={form}
        onClick={onPrimary}
        disabled={primaryDisabled || isBusy}
        className="h-auto w-full max-w-none whitespace-normal p-4 text-sm font-medium"
      >
        {isBusy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        <span>{primaryLabel}</span>
      </CTAButton>
      {onBack && (
        <Button variant="outline" onClick={onBack} disabled={backDisabled} className="w-full p-4 text-sm font-medium">
          Back
        </Button>
      )}
    </div>
  );
}
